import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTheme } from '../context/ThemeProvider'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import swbLogo from '../img/swb-logo.png'
import bwsLogo from '../img/bws-logo.png'

function BookingSuccess() {
  const axios = useAxiosPrivate()
  const navigate = useNavigate()
  const theme = useTheme()
  const logo = theme.brand === 'bws' ? bwsLogo : swbLogo

  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id') // Corrected to match Stripe's {CHECKOUT_SESSION_ID}

  const [status, setStatus] = useState('processing') // 'processing' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (sessionId) {
      processPayment()
    } else {
      setStatus('error')
      setErrorMessage('No session ID found.')
    }
  }, [sessionId])

  const processPayment = async () => {
    try {
      const response = await axios.post('/process-booking', {
        service_name: "GP Service",
        session_id: sessionId
      })
      if (!response.data.error) {
        setStatus('success')
        //auto-redirect after 5 seconds
        setTimeout(() => {
          navigate('/referrals', { replace: true })
        }, 5000)
      } else {
        // This handles cases where the server returns a 200 but error: true
        throw new Error(response.data.message)
      }
    } catch (error) {
      console.error('Error processing payment:', error)
      setStatus('error')
      // Extract the message from your Laravel $this->error() response
      setErrorMessage('There was an issue confiriming your booking, please try again.')
    }
  }

  return (
    <section className="w-screen h-screen py-16">
      <div className="main-bg">&nbsp;</div>
      <div className="flex items-center flex-col z-10 relative">
        <div className="flex">
          <img src={logo} alt="Logo" className="w-72" />
        </div>
        <div
          className="bg-white rounded-xl shadow-2xl py-10 mt-8 px-8 w-full flex flex-col items-center"
          style={{ maxWidth: 600 }}
        >
          {/* STATE: PROCESSING */}
          {status === 'processing' && (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-wba-primary mb-6"></div>
              <h1 className="text-3xl text-wba-primary font-bold text-center mb-4">
                Confirming Appointment
              </h1>
              <p className="text-center text-gray-600">
                Please do not refresh this page...
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="text-green-500 mb-6">
                <svg
                  className="w-16 h-16 mx-auto text-green-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {/* The Circle */}
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    strokeWidth="2"
                  />
                  {/* The Tick */}
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 12l3 3 5-5"
                  />
                </svg>
              </div>
              <h1 className="text-3xl text-green-600 font-bold text-center mb-4">
                Booking Confirmed!
              </h1>
              <div className="text-center mb-6">
                <p className="text-lg text-gray-600">Your booking has been confirmed, you will recieve confirmation shortly.</p>
              </div>
              <button
                onClick={() => navigate('/referrals')}
                className="bg-wba-primary text-white px-6 py-2 rounded-lg font-bold"
              >
                Go to Referrals
              </button>
            </>
          )}

          {/* STATE: ERROR / CANCELLED */}
          {status === 'error' && (
            <>
              <div className="text-red-500 mb-6">
                <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h1 className="text-3xl text-red-600 font-bold text-center mb-4">
                Booking Unsuccessful
              </h1>
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 w-full text-center">
                <p className="text-red-800 font-medium">{errorMessage}</p>
              </div>
              <p className="text-gray-600 text-center mb-6">
                Unfortunately, the appointment slot was taken by someone else or timed out.
                <strong> No funds have been taken from your account.</strong>
              </p>
              <button
                onClick={() => navigate('/')} // Send them back to try a new slot
                className="bg-gray-800 text-white px-6 py-2 rounded-lg font-bold"
              >
                Book Another Appointment
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default BookingSuccess